import React, { useState, useEffect } from 'react';
import { fetchDataFromAPI } from '../common/fetchDataFromAPI';
import '../components/advancedTab.css';


function AdvancedTab({
    advancedFormData,
    setAdvancedFormData,
    setPlotData,
    setIsAuthenticated,
    setLogColor,
    setLogMessage,
    measurementSystem,
    selectedMesTypeButton
}) {
    const [timeoutId, setTimeoutId] = useState(null);

    const handleFormSubmit = async () => {
        console.log("formData", "API FIRED");
        console.log("formData API EXECUTE", advancedFormData);

        try {
            const params = {
                totalPower: advancedFormData.totalPower,
                saturationTemperature: advancedFormData.saturationTemperature,
                condenserSurfaceArea: advancedFormData.condenserSurfaceArea,
                HTC: advancedFormData.HTC,
                Vdot: advancedFormData.Vdot,
                MeasurementSystem: selectedMesTypeButton,
            };

            const url = `simulate`;
            const method = 'GET';
            const token = localStorage.getItem('zuta');

            const data = await fetchDataFromAPI(url, method, params, token);

            if (data && data.error) {
                console.log('Error: ', data);

                if (data.error === "invalid_token" || data.error === "invalid_grant") {
                    setAdvancedFormData({
                        totalPower: 0,
                        saturationTemperature: 0,
                        condenserSurfaceArea: 0,
                        HTC: 1200,
                        Vdot: 8,
                        MeasurementSystem: measurementSystem
                    });
                    setPlotData(null);
                    setIsAuthenticated(false);
                    setLogColor("red");
                    setLogMessage("Access token expired");
                } else {
                    setLogColor("red");
                    setLogMessage(data.message);
                    setPlotData(null);
                }
            } else {
                console.log('API SUCCESS: ', data);
                setPlotData(data);
            }
        } catch (error) {
            console.log('Error:', error);
        }
    };


    useEffect(() => {
    // Validation function
    const isValid = (
        advancedFormData.totalPower > 0 &&
        advancedFormData.saturationTemperature > 0 &&
        advancedFormData.condenserSurfaceArea > 0 &&
        advancedFormData.HTC > 0 &&
        advancedFormData.Vdot > 0 
      );
  
      if (isValid) {
        clearTimeout(timeoutId);
        setTimeoutId(setTimeout(handleFormSubmit, 500));
      } else {
        console.log('Validation failed:', advancedFormData);
      }// eslint-disable-next-line
    }, [
        advancedFormData.totalPower,
        advancedFormData.saturationTemperature,
        advancedFormData.condenserSurfaceArea,
        advancedFormData.HTC,
        advancedFormData.Vdot,
        advancedFormData.MeasurementSystem
    ]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setAdvancedFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    return (
        <>
            <div className='row advancedTab col-lg-10' style={{ color: '#fff' }}>
                <div className='col-lg-2 advancedBtn'>
                    <label htmlFor='totalPower'>Total power</label>
                    <input
                        type='number'
                        id='totalPower'
                        name='totalPower'
                        value={advancedFormData.totalPower}
                        onChange={handleChange}
                    />
                </div>
                <div className='col-lg-2 advancedBtn'>
                    <label htmlFor='saturationTemp'>Saturation temperature</label>
                    <input
                        type='number'
                        id='saturationTemp'
                        name='saturationTemperature'
                        value={advancedFormData.saturationTemperature}
                        onChange={handleChange}
                    />
                </div>
                <div className='col-lg-2 advancedBtn'>
                    <label htmlFor='condenserArea'>Condenser’s surface area</label>
                    <input
                        type='number'
                        id='condenserArea'
                        name='condenserSurfaceArea'
                        value={advancedFormData.condenserSurfaceArea}
                        onChange={handleChange}
                    />
                </div>
                <div className='col-lg-2 advancedBtn'>
                    <label htmlFor='htc'>HTC</label>
                    <input
                        type='number'
                        id='htc'
                        name='HTC'
                        value={advancedFormData.HTC}
                        onChange={handleChange}
                    />
                </div>
                <div className='col-lg-2 advancedBtn'>
                    <label htmlFor='Vdot'>Vdot</label>
                    <input
                        type='number'
                        id='Vdot'
                        name='Vdot'
                        value={advancedFormData.Vdot}
                        onChange={handleChange}
                    />
                </div>
            </div>
        </>
    );
}

export default AdvancedTab;
